export enum NormalizationEnum {
  MIN_MAX = 'Min-max',
  PERCENTILE = 'Percentile',
  EMBEDDING = 'Embedding',
  ONE_HOT = 'One-hot',
  NONE = 'None'
}